
    <div
      fxLayout="column"
      class="notification-item cursor-pointer"
      [ngClass]="{
        'cursor-pointer': cursor
      }"
      (click)="redirect.emit()"
    >
      <div class="mat-subheading-1 no-margin grey-color">
        <strong>{{ notification.message }}</strong>
      </div>
      <div fxLayout="row" fxLayoutAlign="space-between baseline">
        <div fxLayout="column">
          <div class="mat-subheading-1 no-margin grey-color">
            <strong>{{ 'from' | translate }}:</strong>
            {{ notification.fromUser.firstName }}
          </div>
          <div class="mat-subheading-1 no-margin grey-color">
            <strong>{{ 'subject' | translate }}:</strong>
            {{ notification.subject }}
          </div>
        </div>
        <button
          mat-icon-button
          (click)="$event.stopPropagation(); remove.emit()"
        >
          <mat-icon svgIcon="close"></mat-icon>
        </button>
      </div>
    </div>
    <mat-divider></mat-divider>
  